module.exports = __webpack_public_path__ + "static/media/Mobile_Track_Icon.0722d04b.svg";